import React, { PureComponent } from 'react';
import { Col, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import { Icons } from '../../../Health/AssetHealth/components/Icons'
import appConfig from "../../../../config/constants";
import { withRouter } from 'react-router-dom';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import {
  openComponent, setAssetHealthFilterFieldDataQuery
} from "../../../../redux/actions/componentActions";

class HealthAssets extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  notShowRulColumn = () => appConfig.APP === "ANOMALY";

  searchChangeHandler = e => {
    if (e.keyCode === 13) {
      const queryString = `&asset_name=${e.target.value}`;
      const {
        setAssetHealthFilterFieldDataQuery,
        history
      } = this.props;
      setAssetHealthFilterFieldDataQuery(queryString);
      history.push('/asset_health');
    }
  };

  rowClickHandler = row => {
    this.props.openComponent(row);
    this.props.history.push('/asset_health_report');
  };

  render() {
      const { data, t } = this.props;

      const options = {
        searchField: props => <SearchBar {...props} />,
        onRowDoubleClick: (row) => this.rowClickHandler(row)
      };

      function severityLabel (val) {
            let color = '';
            switch (val) {
                case 'CRITICAL' :
                    color = '';
                    break;
                case 'MAJOR' :
                    color = 'orange';
                    break;
                case 'MINOR' :
                    color = 'yellow';
                    break;
                case 'NORMAL' :
                    color = 'green';
                    break;
                default:
                    color = '';
            }
            return color;
        }
        function valueSeverity(cell) {
            return <mark className={severityLabel(cell)}>{cell}</mark>;
        }

        function componentFormat(cell,row) {
            return <React.Fragment><b>{cell}</b><br/>{row.component_type_name}</React.Fragment>;
        }

        function oldAssetsFormat(cell,row) {
            return <React.Fragment><b>{cell}</b><br/>{row.parent_source_type_name}</React.Fragment>;
        }

        function valueAiConfidence(cell) {
            return (
              <React.Fragment>
                <div className={cell==='LOW'?'red-circle':(cell==='MEDIUM'?'yellow-circle':'green-circle')} />
                {cell}
              </React.Fragment>
            )
        }

        const assetsFormate = (cell,row) => {
            return (
              <React.Fragment>
                    <span>
                        <Icons health_score={row.health_score} />
                    </span>
                    <b>{cell}</b><br/>{row.asset_type_name}
              </React.Fragment>
            )
        };

      function columnClassNameFormat(fieldValue, row) {
        return row.review_status === 'PENDING' ? 'event-status-pending' : 'td-column-function-odd-example';
      }

    return (
      <Row className="field">
          <Col lg={12} xs={12} sm={12}>
              <div className="white-bg fixed-height">
                  <div className="title-details">
                      <div className="col-lg-6 col-sm-6 col-xs-6">
                          <h4>{t('dashboard_assets.assets_with_health_issues')}</h4>
                      </div>
                      <div className="col-lg-6 text-right col-sm-6 col-xs-6">
                          <input type="search" onKeyUp={this.searchChangeHandler} />
                      </div>
                  </div>
                  <div className="pro space-top-0 table-fixed-janral">
                      <div className="table-responsive">
                          <BootstrapTable
                              data={data}
                              options={options}
                              hover
                              condensed
                              responsive
                              trClassName="trClassFormat"
                              tableBodyClass="spacingBorder"
                              tableContainerClass="table-fixed table-responsive"
                              tableHeaderClass="tableHeader"
                              bordered={false}
                          >
                            <TableHeaderColumn
                              dataSort
                              dataField="asset_name"
                              dataFormat={assetsFormate}
                              width="25%"
                              columnClassName={ columnClassNameFormat }
                            >
                                {t('asset_health.asset_labels.asset_name')} /
                                {t('asset_health.asset_labels.type')}
                            </TableHeaderColumn>

                            <TableHeaderColumn
                              dataSort
                              dataField="component_name"
                              dataFormat={componentFormat}
                              width="20%"
                            >
                                {t('asset_health.asset_labels.component_name')} /
                                {t('asset_health.asset_labels.type')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                              dataSort
                              dataField="aggregate_status"
                              width="15%"
                            >
                                {t('asset_health.asset_labels.health_status')}
                            </TableHeaderColumn>
                             <TableHeaderColumn
                              dataSort
                              dataField="rul"
                              width="15%"
                              hidden={this.notShowRulColumn()}
                            >
                                {t('asset_health.asset_labels.rul')}
                                ({t('asset_health.asset_labels.days')})
                            </TableHeaderColumn>
                            <TableHeaderColumn
                              dataSort
                              dataFormat={valueAiConfidence}
                              dataField="last_ai_confidence"
                              width="10%"
                            >
                                ({t('asset_health.asset_labels.ai_confidence')})
                            </TableHeaderColumn>
                            <TableHeaderColumn
                              dataSort
                              dataFormat={valueSeverity}
                              dataField="aggregate_severity"
                              width="10%"
                            >
                                ({t('asset_health.asset_labels.severity')})
                            </TableHeaderColumn>
                            <TableHeaderColumn isKey dataField="_id"  hidden={true}></TableHeaderColumn>
                          </BootstrapTable>
                      </div>
                  </div>
              </div>
          </Col>
      </Row>
    );
  }
}

function mapStateToProps({ }) {
  return { };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      openComponent,
      setAssetHealthFilterFieldDataQuery,
    },
    dispatch
  );
}

export default withRouter(withTranslation('common')(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(HealthAssets)
));


const SearchBar = () => {
  return(
    <div className=" title-details search-div col-lg-6 text-right col-sm-6 col-xs-6">
      <input type="search" />
    </div>
  )
};
